import { ActionModal } from '@/src/components/ActionModal'
import { EnpiPickerPanel } from '@/src/features/iso-suite/measures/mesaure-detail/tabs/success-measurement/EnpiPickerPanel'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface ISelectEnpiModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: (enpiIds: number[]) => void
  initialSelectedEnpiIds?: number[]
  actionButtonText?: string
}

export const SelectEnpiModal = ({ isOpen, onClose, onConfirm, initialSelectedEnpiIds, actionButtonText }: ISelectEnpiModalProps) => {
  const { t } = useTranslation()
  const [selectedEnpiIds, setSelectedEnpiIds] = useState<number[]>(initialSelectedEnpiIds ?? [])
  const initialSelectionKey = (initialSelectedEnpiIds ?? []).join(',')

  useEffect(() => {
    if (isOpen) setSelectedEnpiIds(initialSelectionKey ? initialSelectionKey.split(',').map(Number) : [])
  }, [isOpen, initialSelectionKey])

  const onSave = () => {
    if (selectedEnpiIds.length === 0) return
    onConfirm(selectedEnpiIds)
    onClose()
  }

  return (
    <ActionModal
      header={t('dashboard.select_enpi')}
      isOpen={isOpen}
      onClose={onClose}
      size='3xl'
      isCentered
      onSave={onSave}
      isSaveDisabled={selectedEnpiIds.length === 0}
      actionButtonText={actionButtonText ?? t('save')}
      footerProps={{ mt: '12px' }}
    >
      <EnpiPickerPanel
        selectedEnpiIds={selectedEnpiIds}
        selectionMode='multiple'
        onChangeMany={setSelectedEnpiIds}
        allowSingleDeselect={false}
      />
    </ActionModal>
  )
}
